import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { invoicePaymentMethods } from 'src/utilities/invoicePaymentMethods';
import { CookbookSelectWrapper } from 'src/components/CookbookSelectWrapper/CookbookSelectWrapper';

export interface InvoicePaymentMethodProps {
  name: string;
  id: string;
}

export function InvoicePaymentMethod({
  name,
  id,
}: InvoicePaymentMethodProps): JSX.Element {
  const { errors, control } = useFormContext();

  return (
    <CookbookSelectWrapper
      label="Invoice Payment Methods"
      control={control}
      name={name}
      id={id}
      error={errors[name]}
      options={invoicePaymentMethods}
      maxHeight="300px"
      inputSize="medium"
      ariaLabel="Invoice Payment Methods"
      blockWidth
    />
  );
}
